import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';
// utils
import axios, { fetcher, endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------


export async function updatePassword(apiData) {
    const URL = endpoints.canvasser.list;
    try {
      const { data } = await axios.put(endpoints.settings.updatePassword, apiData);
      if (data.code === 200) {
        await mutate(URL);
      }
      return data;
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  }


export async function updateNotifications(apiData) {
    const URL = endpoints.canvasser.list;
    try {
      const { data } = await axios.put(endpoints.settings.updateNotifications, apiData);
      if (data.code === 200) {
        await mutate(URL);
      }
      return data;
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  }

  